import React from 'react'
import {UploadOutlined} from "@ant-design/icons";
import {Button, message, Upload} from "antd";
import config from "../../config";
import cookieOps from "../../services/cookieOps";
import ERROR_MESSAGE from "../../errorMessages";


const FileUpload = ({statusToggle, pathUpdater}) => {

    const handleUploadStatus = ({file}) => {
        if (file.status === 'done' && file.response) {
            message.success('İşlem Başarılı')
            pathUpdater(file.response.url)
            statusToggle(true)
        } else if (file.status === 'error' && file.response) {
            const errors = ERROR_MESSAGE["TR"]
            message.error(errors[file.response.message])
        }
    }

    return(
        <React.Fragment>
            <Upload
                showUploadList={false}
                action={`${config.baseURL}/storage/upload-file`}
                headers={{
                    'Authorization': cookieOps.readCookie('mySweetApple'),
                    'tenantId': config.currentTenant()
                }}
                onChange={handleUploadStatus}
            >
                <Button>
                    <UploadOutlined />
                    Dosya Yükle
                </Button>
            </Upload>
        </React.Fragment>
    )
}
export default FileUpload